import { jsx, jsxs } from "react/jsx-runtime";
import { Spacer, FormField, Select, FormHelp, Flex, Label } from "@zillow/constellation";
import React from "react";
import { useFormContext, useFormState } from "react-hook-form";
import FieldTooltip from "./FieldTooltip.esm.js";
function SelectField({
  label,
  required,
  options,
  name,
  config,
  description,
  onChange,
  onBlur,
  placeholder,
  disabled,
  tooltip
}) {
  var _a;
  const form = useFormContext();
  const proxyFormState = useFormState();
  const error = (_a = proxyFormState == null ? void 0 : proxyFormState.errors[name]) == null ? void 0 : _a.message;
  const field = form.register(name, config);
  return /* @__PURE__ */ jsx(Spacer, { marginBottom: "xs", children: /* @__PURE__ */ jsx(FormField, { label: /* @__PURE__ */ jsxs(Flex, { display: "flex", alignItems: "center", children: [
    /* @__PURE__ */ jsx(Label, { children: label }),
    tooltip && /* @__PURE__ */ jsx(FieldTooltip, { ...tooltip })
  ] }), description: /* @__PURE__ */ jsx(FormHelp, { error: Boolean(error), children: error || description || /* @__PURE__ */ jsx(React.Fragment, { children: " " }) }), control: /* @__PURE__ */ jsxs(Select, { disabled, error: Boolean(error), ...field, onBlur: (e) => {
    field.onBlur(e);
    onBlur == null ? void 0 : onBlur(e);
  }, onChange: (e) => {
    field.onChange(e);
    onChange == null ? void 0 : onChange(e);
  }, children: [
    placeholder && /* @__PURE__ */ jsx("option", { disabled: true, selected: true, value: "", children: placeholder }),
    options.map((option) => /* @__PURE__ */ jsx("option", { value: option.value, children: option.label }, option.label))
  ] }), required }) });
}
export {
  SelectField as default
};
